import React from 'react';
import PropTypes from 'prop-types';
import Label from 'components/ui/form/label';
import Input from 'components/ui/form/input';
import { FormFieldError } from 'components/ui/index';
import classNames from 'classnames';
import FormGroup from 'components/ui/form/form_group';

const FormCheckboxInput = ({ label, input: { onChange, ...restInput }, meta, onCheck, className, disabled, formGroupProps = {}, ...otherProps }) => {
  const { className: formGroupPropsClassName } = formGroupProps;
  return (
    <FormGroup className={classNames('form-check', className, formGroupPropsClassName)} {...formGroupProps}>
      <Input
        type="checkbox"
        invalid={meta.touched && !!meta.error}
        {...restInput}
        id={restInput.name}
        {...otherProps}
        disabled={disabled}
        checked={restInput.value === 'true' || restInput.value === true}
        onChange={(ev) => {
          onChange(ev.target.checked);
          if (onCheck) {
            onCheck(ev.target.checked);
          }
          ev.target.blur();
        }}
      />
      <Label className="cursor-pointer" check htmlFor={restInput.name}>
        {label}
      </Label>
      <FormFieldError meta={meta} />
    </FormGroup>
  );
};

FormCheckboxInput.defaultProps = {
  label: null,
  meta: {
    error: null,
    touched: false,
  },
  onCheck: null,
};

FormCheckboxInput.propTypes = {
  label: PropTypes.any,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  onCheck: PropTypes.func,
};

export default FormCheckboxInput;
